//船运接单

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 船主接单状态
 */
class CarrierState extends UltMeta {
    PROCESSING = new Meta(1, "处理中");
    CONFIRMING = new Meta(2, "确认中");
    ORDER_ACCEPTANCE_FAILED = new Meta(3, "报价失败");
    SUCCESSFUL_ORDER_ACCEPTANCE = new Meta(4, "报价成功");
}

export const CARRIER_STATE = new CarrierState();

/**
 * 频台接单状态
 */
class PlatformState extends UltMeta {
    PROCESSING = new Meta(1, "处理中");
    // OWENER_TO_BE_CONFIRMED = new Meta(2, "待船主确认");
    ORDER_ACCEPTANCE_FAILED = new Meta(3, "报价失败");
    SUCCESSFUL_ORDER_ACCEPTANCE = new Meta(4, "报价成功");
}

export const PLATFORM_STATE = new PlatformState();

/**
 * 报价拒绝来源
 */
class RejectOrigin extends UltMeta {
    BACKSTAGE = new Meta(1, "被后台拒绝");
    OTHERS = new Meta(2, "其他原因导致的拒绝");
}
export const REJECT_ORIGIN = new RejectOrigin();
